import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button as RbButton, Form } from 'react-bootstrap';
import { Wrapper, Button, Menu, MenuItem } from 'react-aria-menubutton';
const uuid = require('uuid');

const ServerRequest = require('../../actions/request');
const ShortCourseActions =  require('../../actions/ShortCourseActions');
import ErrorBox from '../common/ErrorBox';

const PermissionsUtil = require('../../../../app/shared/PermissionsUtil');
const Globals = require('../../../../app/globals');
import ProjectSelector from '../common/ProjectSelector';

const propTypes = {
    show: PropTypes.bool,
    channelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    closeHandler: PropTypes.func.isRequired,
    importStacks: PropTypes.array,
};

const defaultProps = {
    show: false,
    importStacks: [],
};

const STACK_IMPORT_NOTES = '\
Notes:\n\
1. All activities used by the course will also be stack imported. These activities will need to be published before they will be visible in the imported course.\n\n\
2. Imported activities are given new activity ids (normal stack import behavior). As a consequence, importing multiple courses that use a common set of activities, or the same course multiple times will create new copies of the activities.\n\
';
                        
class StackImportShortCourseModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            devImportStack: '',
            devImportError: '',
            devImportShortCourseId: '',
            devImportShortCourseVersion: '',
        };

    }

    // import dev tool functions
    setImportStack=(stackName)=>{
        this.setState({
            devImportStack: stackName,
            devImportError: '',
        });
    }

    setImportShortCourseId=(e)=>{
        this.setState({
            devImportShortCourseId: e.target.value,
            devImportError: '',
        });
    }

    /*setImportVersion=(e)=>{
        this.setState({
            devImportShortCourseVersion: e.target.value,
            devImportError: '',
        });
    }*/

    doImport=()=>{
        ServerRequest.makeRequest(`/authoring/projects/${this.props.projectId}/short_courses/import`, 'POST', JSON.stringify({
                projectID: this.props.projectId, // redundant but allows easier code pipeline
                activityProjectID: this.state.projectForActivities, // destination for imported activities
                stack: this.state.devImportStack,
                shortCourseHash: this.state.devImportShortCourseId,
                version:  this.state.devImportShortCourseVersion,
            }))
            .then((courseDoc) => {
                console.log("import complete.");
                ShortCourseActions.getShortCourse(uuid.v4(), { channelId: this.props.channelId, shortCourseId: courseDoc.id });
                this.props.closeHandler();
            })
            .catch((err) => {
                this.setState({
                    devImportError: err.responseText
                });
            });
    }
    
    onSetProjectForActivities=(projectForActivities)=>{
        this.setState({projectForActivities});
    }


    render() {
        if (!this.props.importStacks || this.props.importStacks.length === 0) {
            return null;
        }

        return (
            <Modal
                className='import-modal'
                show
                enforceFocus={false}
                autoFocus
                backdrop={false}
                animation={false}
                keyboard
                onHide={this.props.closeHandler}
            >
                <Modal.Header closeButton onHide={this.props.closeHandler}>
                    <Modal.Title>Dev Import (EXPERIMENTAL)</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ErrorBox
                        error={this.state.devImportError ? { message: this.state.devImportError } : null}
                    />
                    <Form>
                        <Form.Group>
                            <Wrapper className='AriaMenuButton inline-block' onSelection={this.setImportStack}>
                                <Button className="AriaMenuButton-trigger flat-button primary btn-width2">
                                    {this.state.devImportStack || 'select stack'}
                                </Button>
                                <Menu>
                                    <ul className='AriaMenuButton-menu'>
                                        {this.props.importStacks.map((stackName) =>
                                            <li className='AriaMenuButton-menuItemWrapper' key={stackName}>
                                                <MenuItem className="AriaMenuButton-menuItem" value={stackName} text={stackName}>
                                                    {stackName}
                                                </MenuItem>
                                            </li>
                                        )}
                                    </ul>
                                </Menu>
                            </Wrapper>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Course Hash</Form.Label>
                            <Form.Control
                                type="text"
                                htmlSize={40}
                                maxLength={40}
                                onChange={this.setImportShortCourseId}
                            />
                        </Form.Group>
                        {/*<Form.Group>
                            <Form.Label>Version</Form.Label>
                            <Form.Control
                                type="text"
                                htmlSize={10}
                                maxLength={10}
                                onChange={this.setImportVersion}
                            />
                        </Form.Group>*/}
                        <ProjectSelector
                            label="Imported activities project:"
                            selectedProject={this.state.projectForActivities}
                            onSelect={this.onSetProjectForActivities}
                            excludeProject={this.props.projectId}
                            permissionsFunc={PermissionsUtil.canCreateNewActivity}
                            contentType={Globals.content_type.ACTIVITY}
                            restrictToChannelId={this.props.restrictToChannelId}
                        />
                        <br style={{height:'1rem'}}/>
                        <div className="font-style-italic">{STACK_IMPORT_NOTES}</div>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <RbButton disabled={!this.state.projectForActivities} onClick={this.doImport}>Import</RbButton>
                </Modal.Footer>
            </Modal>
        );
    }
}

StackImportShortCourseModal.propTypes = propTypes;
StackImportShortCourseModal.defaultProps = defaultProps;

export default StackImportShortCourseModal;